import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/page-layout/PageHeader";

import StoreCreatedGif from "../../../assets/images/store-created.gif";
import StoreCreatedOverlay from "../../../assets/images/store-created-overlay.png";
import RewardMusic from "../../../assets/musics/reward.mp3";
import { useNavigate } from "react-router";
 import { toast } from "react-hot-toast";
import confetti from "canvas-confetti";

const NewStoreCreated = () => {
  const navigate = useNavigate();

  const navigateToStorePage = () => {
    navigate("/store");
    // toast.success(
    //   "🎉 New store has been created. Congratulations on your new store!",
    //   {
    //     position: "top-center",
    //     style: {
    //       fontWeight: "bold",
    //       fontSize: "1.1rem",
    //       background: "linear-gradient(90deg, #43e97b 0%, #38f9d7 100%)",
    //       color: "#222",
    //       borderRadius: "8px",
    //       textAlign: "center",
    //       boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
    //       ...(window.matchMedia &&
    //       window.matchMedia("(prefers-color-scheme: dark)").matches
    //         ? {
    //             color: "#fff",
    //             background: "linear-gradient(90deg, #232526 0%, #4caf50 100%)",
    //           }
    //         : {}),
    //     },
    //     icon: "🏬",
    //   }
    // );
    toast.success(" 🎉 New store has been created. Congratulations! 🏬", {
      position: "top-center",
      duration: 4000,
      style: {
        fontWeight: "bold",
        fontSize: "1.1rem",
        borderRadius: "8px",
        textAlign: "center",
        color: window.matchMedia("(prefers-color-scheme: dark)").matches ? "#fff" : "#222",
        background: window.matchMedia("(prefers-color-scheme: dark)").matches
          ? "linear-gradient(90deg, #232526 0%, #4caf50 100%)"
          : "linear-gradient(90deg, #43e97b 0%, #38f9d7 100%)",
      },
    });

  };

  useEffect(() => {
    const timer = setTimeout(() => {
      navigateToStorePage();
    }, 9000);
    const confettiTimer = setTimeout(() => {
      // confetti
      var end = Date.now() + 15 * 1000;

      // go Buckeyes!
    var colors = ["#ffe066", "#222222"];

      (function frame() {
        confetti({
          particleCount: 2,
          angle: 60,
          spread: 55,
          origin: { x: 0 },
          colors: colors,
        });
        confetti({
          particleCount: 2,
          angle: 120,
          spread: 55,
          origin: { x: 1 },
          colors: colors,
        });

        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      })();
    }, 5000);
    return () => {
      clearTimeout(timer);
      clearTimeout(confettiTimer);
    };
  }, []);

  return (
    <div>
      <Box>
        <PageHeader
          textAlignedCenter
          title={"Store Created"}
          lead={"New store has been successfully created!"}
        />

        {1 && (
          <div className="store-creation-wrapper">
            <img src={StoreCreatedOverlay} className="bg-overlay" />
            <img src={StoreCreatedGif} className="store-created-img" />
          </div>
        )}
      </Box>
    </div>
  );
};

export default NewStoreCreated;
